import { render, staticRenderFns } from "./MenuApp.vue?vue&type=template&id=29f5a1f6&scoped=true&"
import script from "./MenuApp.vue?vue&type=script&lang=js&"
export * from "./MenuApp.vue?vue&type=script&lang=js&"
import style0 from "./MenuApp.vue?vue&type=style&index=0&id=29f5a1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f5a1f6",
  null
  
)

export default component.exports